"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledItemTitle = exports.StyledItemSummary = exports.StyledItemHeader = exports.StyledItemContent = exports.StyledItemContainer = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _userflow = _interopRequireDefault(require("../../../../styles/userflow"));
var _RadioButton = require("../../../RadioButton");
var _Collapsible = _interopRequireDefault(require("../../../Collapsible"));
var RadioAccordionItem = function RadioAccordionItem(props) {
  var children = props.children,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    _props$index = props.index,
    index = _props$index === void 0 ? 0 : _props$index,
    _props$title = props.title,
    title = _props$title === void 0 ? '' : _props$title,
    _props$summary = props.summary,
    summary = _props$summary === void 0 ? '' : _props$summary,
    _props$isActive = props.isActive,
    isActive = _props$isActive === void 0 ? false : _props$isActive,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$onClick = props.onClick,
    _onClick = _props$onClick === void 0 ? Function.prototype : _props$onClick;
  return /*#__PURE__*/_react["default"].createElement(StyledItemContainer, {
    className: className,
    key: title
  }, /*#__PURE__*/_react["default"].createElement(StyledRadioBlock, null, /*#__PURE__*/_react["default"].createElement(StyledRadio, {
    name: index,
    value: index,
    checked: isActive,
    disabled: disabled,
    onClick: function onClick() {
      return _onClick();
    }
  })), /*#__PURE__*/_react["default"].createElement(InnerBlock, null, /*#__PURE__*/_react["default"].createElement(StyledItemHeader, {
    onClick: function onClick() {
      return _onClick();
    }
  }, /*#__PURE__*/_react["default"].createElement(StyledItemTitle, {
    isChecked: isActive
  }, title), /*#__PURE__*/_react["default"].createElement(StyledItemSummary, {
    isChecked: isActive
  }, summary)), /*#__PURE__*/_react["default"].createElement(_Collapsible["default"], {
    isCollapsed: !isActive || disabled
  }, /*#__PURE__*/_react["default"].createElement(StyledItemContent, null, children))));
};
var InnerBlock = _styledComponents["default"].div.withConfig({
  displayName: "RadioAccordionItem__InnerBlock",
  componentId: "sc-1sy71ln-0"
})(["width:100%;"]);
var StyledRadioBlock = _styledComponents["default"].div.withConfig({
  displayName: "RadioAccordionItem__StyledRadioBlock",
  componentId: "sc-1sy71ln-1"
})(["margin-right:5px;"]);
var StyledRadio = (0, _styledComponents["default"])(_RadioButton.StyledRadioButton).withConfig({
  displayName: "RadioAccordionItem__StyledRadio",
  componentId: "sc-1sy71ln-2"
})(["display:flex;align-items:start;"]);
var StyledItemContainer = exports.StyledItemContainer = _styledComponents["default"].div.withConfig({
  displayName: "RadioAccordionItem__StyledItemContainer",
  componentId: "sc-1sy71ln-3"
})(["width:100%;display:flex;margin:8px 0;border-radius:4px;"]);
var StyledItemHeader = exports.StyledItemHeader = _styledComponents["default"].div.withConfig({
  displayName: "RadioAccordionItem__StyledItemHeader",
  componentId: "sc-1sy71ln-4"
})(["width:100%;display:block;cursor:pointer;margin-bottom:8px;"]);
var StyledItemTitle = exports.StyledItemTitle = _styledComponents["default"].div.withConfig({
  displayName: "RadioAccordionItem__StyledItemTitle",
  componentId: "sc-1sy71ln-5"
})(["font-weight:500;line-height:16px;font-size:16px;", ""], function (_ref) {
  var isChecked = _ref.isChecked;
  return !isChecked && "\n    font-weight: normal;\n  ";
});
var StyledItemSummary = exports.StyledItemSummary = _styledComponents["default"].div.withConfig({
  displayName: "RadioAccordionItem__StyledItemSummary",
  componentId: "sc-1sy71ln-6"
})(["font-size:14px;padding-top:3px;", ""], function (_ref2) {
  var isChecked = _ref2.isChecked;
  return !isChecked && "\n    color: ".concat(_userflow["default"].colors.greyLight, "\n  ");
});
var StyledItemContent = exports.StyledItemContent = _styledComponents["default"].div.withConfig({
  displayName: "RadioAccordionItem__StyledItemContent",
  componentId: "sc-1sy71ln-7"
})(["border-radius:4px;width:100%;display:block;margin-bottom:8px;"]);
var _default = exports["default"] = RadioAccordionItem;